import * as AppConstants from 'app/AppConstants';
import {
  selectIsChartPickerActive,
  selectIsFilterActive,
  selectIsTableActive,
} from './cardDetailSelectors';
import {analyticsTrack} from 'utilities/analytics';
import {ADOBE_ANALYTICS_EVENTS} from 'app/Analytics';

export const disableChartPicker = () => ({
  type: AppConstants.CARD__CHART_PICKER_DEACTIVATED,
});

export const toggleChartPicker = () => (dispatch, getState) =>
  dispatch({
    type: selectIsChartPickerActive(getState())
      ? AppConstants.CARD__CHART_PICKER_DEACTIVATED
      : AppConstants.CARD__CHART_PICKER_ACTIVATED,
  });

export const toggleFilter = () => (dispatch, getState) =>
  dispatch({
    type: selectIsFilterActive(getState())
      ? AppConstants.CARD__FILTER_DEACTIVATED
      : AppConstants.CARD__FILTER_ACTIVATED,
  });

export const toggleTable = () => (dispatch, getState) => {
  const isTableActive = selectIsTableActive(getState());
  if (!isTableActive) {
    analyticsTrack(ADOBE_ANALYTICS_EVENTS.CARD__TABLE_VIEW);
  }

  dispatch({
    type: isTableActive
      ? AppConstants.CARD__TABLE_DEACTIVATED
      : AppConstants.CARD__TABLE_ACTIVATED,
  });
};

export const loadFeatures = (cardId, features) => ({
  type: AppConstants.CARD__FEATURES_LOADED,
  payload: {
    cardId,
    features,
  },
});
